export default {
    "created": "Job-ul a fost creat cu succes",
    "updated": "Job-ul a fost actualizat cu succes",
    "deleted": "Job-ul a fost șters cu succes",
    "restored": "Job-ul a fost restaurat cu succes",
}
